const { REACT_APP_URL = "", REACT_APP_RETAILSTAT_URL = "" } = process.env;

const RETURN_TO_KEY = "return_to";

export const getLoginRedirectAddress = () => {
    sessionStorage.setItem(RETURN_TO_KEY, window.location.href);

    const relayState = encodeURIComponent(`${REACT_APP_URL}/auth/callback`);

    return `${REACT_APP_RETAILSTAT_URL}/api/services/poi?relayState=${relayState}`;
};

export const getRequestAccessRedirectAddress = () =>
    `${REACT_APP_RETAILSTAT_URL}/#m/request-access/poi`;

export const getIntendedReturnTo = () => {
    const returnTo = sessionStorage.getItem(RETURN_TO_KEY);
    sessionStorage.removeItem(RETURN_TO_KEY);

    return returnTo;
};
